import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CustomIcons } from '@shared/models/custom-icons';
import { tap } from 'rxjs/operators';
import { Locale } from '@shared/models/locale';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import { DataState } from '../../data-state.service';

@Component({
  selector: 'app-filter-table-dialog',
  templateUrl: './filter-table-dialog.component.html',
  styleUrls: ['./filter-table-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterTableDialogComponent implements OnInit {
  private _dataGroup = ['accessibility', 'summerSeason', 'winterSeason', 'allSeasons', 'withMap', 'withoutMap', 'iso'];
  private _catalogGroup = ['ordinaryDict', 'regionalDict', 'federalDict'];
  private _toggleDisableFields = [...this._dataGroup, ...this._catalogGroup];
  public icons = CustomIcons;
  public isRuLocale = true;
  public langChange$: Observable<LangChangeEvent>;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public readonly close = new EventEmitter();
  public filterForm = new UntypedFormGroup({
    newRecommendedFavorites: new UntypedFormControl(false),
    datasetType: new UntypedFormControl(null),
    activeStatus: new UntypedFormControl(false),
    archiveStatus: new UntypedFormControl(false),
    accessibility: new UntypedFormControl(false),
    summerSeason: new UntypedFormControl(false),
    winterSeason: new UntypedFormControl(false),
    allSeasons: new UntypedFormControl(false),
    withMap: new UntypedFormControl(false),
    withoutMap: new UntypedFormControl(false),
    iso: new UntypedFormControl(false),
    ordinaryDict: new UntypedFormControl(false),
    regionalDict: new UntypedFormControl(false),
    federalDict: new UntypedFormControl(false)
  });
  public disableObserver$ = this.filterForm.get('datasetType')?.valueChanges.pipe(
    tap(val => {
      let fields: string[];
      switch (val) {
        case true:
          fields = this._catalogGroup;
          break;
        case false:
          fields = this._dataGroup;
          break;
        default:
          fields = this._toggleDisableFields;
      }

      Object.keys(this.filterForm.controls).forEach(key => {
        if (this._toggleDisableFields.includes(key)) {
          if (fields.includes(key)) {
            (this.filterForm.controls[key] as UntypedFormControl).enable({ emitEvent: false });
          } else {
            (this.filterForm.controls[key] as UntypedFormControl).reset(false, { emitEvent: false });
            (this.filterForm.controls[key] as UntypedFormControl).disable({ emitEvent: false });
          }
        }
      });
    })
  );
  constructor(private dataState: DataState, private translateService: TranslateService) {}

  private setText(lang: Locale): void {
    if (lang === Locale.RU_RU) {
      this.isRuLocale = true;
    } else {
      this.isRuLocale = false;
    }
  }

  public chooseMapFilter(oppositeFilterName: string): void {
    this.filterForm.get(oppositeFilterName)?.patchValue(false);
  }

  public ngOnInit(): void {
    this.setText(this.translateService.currentLang as Locale);
    this.langChange$ = this.translateService.onLangChange.pipe(
      tap(res => {
        this.setText(res.lang as Locale);
      })
    );
    const currentFormValue = this.dataState.filterForm.value;
    Object.keys(currentFormValue).forEach(key => {
      if (currentFormValue[key]) {
        this.filterForm.get(key)?.setValue(currentFormValue[key]);
      }
    });
  }

  public onSubmit(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.dataState.filterForm.next(this.filterForm.value);
    this.close.emit();
  }

  public reset(): void {
    this.dataState.setDefaultFilterForm();
    this.close.emit();
  }

  public closeDialog(): void {
    this.close.emit();
  }
}
